var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentsIconLargeBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.222 44.858a4.593 4.593 0 0 0 4.593 4.592h43.63a4.593 4.593 0 0 0 4.593-4.592v-19.52a.574.574 0 0 0-.574-.574H5.796a.574.574 0 0 0-.574.575v19.519Zm37.89-5.167h6.89a1.722 1.722 0 1 1 0 3.444h-6.89a1.722 1.722 0 1 1 0-3.444Zm-28.705-9.186h18.371a1.722 1.722 0 0 1 0 3.445h-18.37a1.722 1.722 0 1 1 0-3.445Zm0 9.186h6.89a1.722 1.722 0 1 1 0 3.444h-6.89a1.722 1.722 0 1 1 0-3.444ZM58.038 17.301a4.593 4.593 0 0 0-4.592-4.592H9.815A4.593 4.593 0 0 0 5.222 17.3v3.445a.574.574 0 0 0 .574.574h51.668a.574.574 0 0 0 .574-.574V17.3Z",
    fill: "#4287CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsIconLargeBlue);
export default __webpack_public_path__ + "static/media/payments-icon-large-blue.cf6916ba2c7541cdf7222525e7b2471d.svg";
export { ForwardRef as ReactComponent };